import { FOOTER_LINK } from './actionTypes';

const initialState = {
  footerLink: null,
  loading: {
    footerLink: false,
  },
  error: {
    footerLink: null,
  },
};

const FooterLinkReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case FOOTER_LINK.FOOTER_LINK_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, footerLink: true },
        error: { ...state.error, footerLink: null },
      };
    case FOOTER_LINK.FOOTER_LINK_SUCCESS:
      return {
        ...state,
        footerLink: payload,
        loading: { ...state.loading, footerLink: false },
      };
    case FOOTER_LINK.FOOTER_LINK_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, footerLink: false },
        error: { ...state.error, footerLink: error },
      };
    default:
      return state;
  }
};

export default FooterLinkReducer;
